import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@src/lib/http/useAxios";
import { GetAllTenanciesResponse } from "./types";

const removeDuplicateTenancies = (tenancies: GetAllTenanciesResponse[]) => {
  return tenancies.filter((item, index, self) => index === self.findIndex((t) => t.tenancyEntityId === item.tenancyEntityId));
};

export const useGetAllTenancies = () => {
  const { instance, isEnabled } = useAxios("TENANT_API");

  return useQuery<GetAllTenanciesResponse[]>({
    queryKey: ["tenancy"],
    queryFn: async () => {
      const response = await instance.get("/tenancy");
      return removeDuplicateTenancies(response.data);
    },
    enabled: isEnabled
  });
};
